import { render, staticRenderFns } from "./mainPersonsList.vue?vue&type=template&id=a10d3b00&scoped=true"
import script from "./mainPersonsList.vue?vue&type=script&lang=js"
export * from "./mainPersonsList.vue?vue&type=script&lang=js"
import style0 from "./mainPersonsList.vue?vue&type=style&index=0&id=a10d3b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d3b00",
  null
  
)

export default component.exports